import React, { Component } from 'react';
import glossaryData from '../glossaryData.json';

export default class Calculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
    };

    this.onChange = this.onChange.bind(this);
    this.reset = this.reset.bind(this);
  }

  onChange(e, name) {
    this.setState({ search: e.target.value });
  }

  reset() {
    this.setState({
      search: '',
    });
  }

  render() {
    if (this.state.search != '') {
      var data = glossaryData.filter(g => g.name.includes(this.state.search) || g.value.includes(this.state.search));
    } else {
      var data = glossaryData;
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="paper">
            <h2>Search</h2>
            <div class="row">
              <div className="col-md-6">
                <input
                  className="form-control"
                  type="text"
                  name="search"
                  placeholder="enter search"
                  onChange={this.onChange}
                  value={this.state.search}
                />
              </div>
              <div className="col-md-6">
                <button onClick={this.reset} className="btn btn-default ">
                  clear
                </button>
                <hr />
              </div>
            </div>
          </div>
          {data.length < 0 && <h4 className="lead text-center">Could not find term</h4>}
          {data.length > 0 &&
            data.map(d => (
              <div className="col-sm-12 col-md-12 paper" key={d.name}>
                <h4>{d.name}</h4>
                <p>{d.value}</p>
              </div>
            ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Glossary.jsx